module.exports = __webpack_public_path__ + "img/shop03.d25d4944.jpg";